import GoogleMapsPage from './mapContainer';
import withGoogleWrapper from './withGoogleWrapper';


export default GoogleMapsPage;

export { withGoogleWrapper };
